import React from "react";

import { Home, Refresh } from "@mui/icons-material";
import { Box } from "@mui/material";

import storageKey from "../../config/storageKey";
import { Dev } from "../../config/util/consoleUtil";

import MainSolidButton from "../../components/MainSolidButton";
import MainText from "../../components/MainText";

type ErrorExceptionPageProps = {
  error: Error;
  errorInfo: { componentStack: string };
};

export default function ErrorExceptionPage({ error, errorInfo }: ErrorExceptionPageProps) {
  const [showLog] = React.useState(
    window.localStorage.getItem(storageKey.SHOW_ERROR) ? true : false
  );

  // const { currentUserState } = useAuth();

  // const CreateLog = ErrorLogService.Create();

  console.log(...new Dev("Error Details", error).Error());

  // const handleLogEvent = async () => {
  //   try {
  //     const dateNow = new Date();

  //     let reqBody = {
  //       createdAtISO: dateNow.toISOString(),
  //       createdAtTimestamp: dateNow.getTime(),
  //       errorTitle: error.toString(),
  //       screen: window.location.href,
  //       serverTimestamp: serverTimestamp(),
  //       version: String(process.env.REACT_APP_CURRENT_VERSION),
  //       errorStack: errorInfo.componentStack,
  //     } as BodyErrorLogType;

  //     if (currentUserState) {
  //       reqBody.user = {
  //         uid: currentUserState?.uid,
  //         email: String(currentUserState?.email),
  //       };
  //     }

  //     CreateLog.runRequest(reqBody);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  React.useEffect(() => {
    window.localStorage.setItem(storageKey.CRASH_COUNT, "true");
    // handleLogEvent();
  }, []);

  return (
    <Box
      style={{ minHeight: "90vh", width: "100%" }}
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      py={4}
    >
      <Box style={{ width: "90%", maxWidth: "450px" }}>
        <MainText center color="regular" size="body">
          Uncaught
        </MainText>

        <MainText center color="black" size="title">
          Erro Desconhecido
        </MainText>

        <Box mb={2}>
          <MainText center color="black" size="body">
            {window.location.href}
          </MainText>
        </Box>

        {process.env.NODE_ENV === "development" || showLog ? (
          <React.Fragment>
            <details style={{ overflow: "auto" }}>
              <p style={{ wordBreak: "break-word" }}>{error && error.toString()}</p>
              <br />
              <br />
              <p style={{ wordBreak: "break-word" }}>{errorInfo.componentStack}</p>
            </details>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <MainText center color="regular" size="caption">
              Parece que ocorreu um erro enquanto você navegava no site.
            </MainText>
            <Box my={2}>
              <MainText center color="regular" size="caption">
                Nós já recebemos uma notificação com o que aconteceu e vamos corrigir o mais rápido
                possível.
              </MainText>
            </Box>
            <MainText center color="regular" size="caption">
              Caso o erro persista você pode entrar em contato conosco através do fomulário logo
              abaixo.
            </MainText>
          </React.Fragment>
        )}

        <Box display={"flex"} justifyContent="center" alignItems={"center"} gap={2} sx={{ mt: 5 }}>
          <MainSolidButton
            text="Início"
            icon={<Home />}
            onClick={() => window.location.replace("/")}
          />

          <MainSolidButton
            text="Atualizar"
            icon={<Refresh />}
            onClick={() => window.location.reload()}
          />
        </Box>
      </Box>
    </Box>
  );
}
